import { Component, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import {
  ColorOptions, AdditionalColorOptions, TrimOptions, FactoryOptions,
  LocalOptions, PackageOptions, RimOptions, UpholsteryOptions
} from '../normal-mode-index'
import { Subscription } from 'rxjs/Subscription';
import { CommonDataService, DataLoaderService } from '../service-call-index';
import { Utils } from '../../../../shared/utils';
import { VehicleInfoService } from '../../../../services/vehicle-info.service';

@Component({
  selector: 'normal-mode-option-selection',
  templateUrl: './normal-mode-option-selection.template.html',
  styleUrls: ['./normal-mode-option-selection.css']
})
export class NormalModeOptionSelection{
  public loadComponent: Component;
  public tabId = 'defaultOpen';
  public tablinks;
  public hideIfSmartVeh = false;
  private subscription: Subscription;
  public vehicleInfo: any;

  constructor(private commonDataService: CommonDataService, private vehicleInfoService: VehicleInfoService, private dataLoaderService: DataLoaderService) {
    this.vehicleInfo = this.vehicleInfoService.extractData();
    if (this.dataLoaderService.data.additionalColor.length > 0)
      this.hideIfSmartVeh = true;
  }

  ngOnInit() {
    this.loadComponent = ColorOptions;
   
    this.subscription = this.commonDataService.notifyObservable$.subscribe((res) => {
      this.openNextTab(res.option);
    });
  }
  ngAfterViewInit(){
    document.getElementById(this.tabId).className = "tablinks active";
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  openNextTab(id) {
    if (id === 'defaultOpen')
      this.loadComponent = ColorOptions;
    if (id === 'activeAddColor')
      this.loadComponent = AdditionalColorOptions;
    if (id === 'activeUpholstery')
      this.loadComponent = UpholsteryOptions;
    if (id === 'activeTrim')
      this.loadComponent = TrimOptions;
    if (id === 'activeRim')
      this.loadComponent = RimOptions;
    if (id === 'activeFactory')
      this.loadComponent = FactoryOptions;
    if (id === 'activeLocal')
      this.loadComponent = LocalOptions;
    if (id === 'activePackage')
      this.loadComponent = PackageOptions;

    this.changeActiveTablinks(id);
  }
  changeActiveTablinks(id) {
    this.tabId = id;
    this.tablinks = document.getElementsByClassName("tablinks");
    for (let i = 0; i < this.tablinks.length; i++) {
      this.tablinks[i].className = this.tablinks[i].className.replace("active", "");
    }
    document.getElementById(this.tabId).className = "tablinks active";
  }

  isMarketCA_N(){
		return Utils.isCountryCA_N(this.vehicleInfo.orderingMarket);
	}
	
	isMarketCA_T(){
		return Utils.isCountryCA_T(this.vehicleInfo.orderingMarket);
  }
  
  isMarketMX(){
		return Utils.isCountryMX(this.vehicleInfo.orderingMarket);
	}

  isMarketEG(){
    return Utils.isCountryEG(this.vehicleInfo.orderingMarket);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/normal-screen-components/normal-mode-option-selection/normal-mode-option-selection.ts